var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 3.25H6C3.37665 3.25 1.25 5.37665 1.25 8V9.22305C1.25 9.78862 1.64428 10.1979 2.07079 10.345C2.75802 10.5819 3.25 11.2345 3.25 12C3.25 12.7655 2.75802 13.4181 2.07079 13.655C1.64428 13.8021 1.25 14.2114 1.25 14.777V16C1.25 18.6234 3.37665 20.75 6 20.75H14.25V17C14.25 16.5858 14.5858 16.25 15 16.25C15.4142 16.25 15.75 16.5858 15.75 17V20.75H18C20.6234 20.75 22.75 18.6234 22.75 16V14.777C22.75 14.2114 22.3557 13.8021 21.9292 13.655C21.242 13.4181 20.75 12.7655 20.75 12C20.75 11.2345 21.242 10.5819 21.9292 10.345C22.3557 10.1979 22.75 9.78862 22.75 9.22305V8C22.75 5.37665 20.6234 3.25 18 3.25H15.75V7C15.75 7.41421 15.4142 7.75 15 7.75C14.5858 7.75 14.25 7.41421 14.25 7V3.25ZM15 9.75C15.4142 9.75 15.75 10.0858 15.75 10.5V13.5C15.75 13.9142 15.4142 14.25 15 14.25C14.5858 14.25 14.25 13.9142 14.25 13.5V10.5C14.25 10.0858 14.5858 9.75 15 9.75Z",
    fill: "#ED1C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.1b7b2621986f8815ffa63f0d1e0a13e4.svg";
export { ForwardRef as ReactComponent };